import React, {PureComponent, createRef} from 'react'
import classnames from 'classnames'

import { formatClassNames } from "../../utilities";

import "./FloatNumberInput.css";

export default class FloatNumberInput extends PureComponent {
  state = {
    value: "",
  };

  inputRef = createRef();

  componentDidMount() {
    // set the initial value
    const value = this.props.value || this.props.defaultValue;
    const initialValue = this.formatFloat(value);

    this.setState({ value: initialValue });
  }

  componentDidUpdate(prevProps) {
    const currentValue = this.formatFloat(this.props.value);
    const prevValue = this.formatFloat(prevProps.value);

    if (prevValue !== currentValue) {
      this.setState({ value: currentValue });
    }
  }

  isMaxDecimal = (value) => {
    const splitValue = String(value).split(".");
    const decimalLength = splitValue[1] ? splitValue[1].length : 0;
    return decimalLength < 3;
  };

  isAllowedChar = (char) => {
    const dotCount = (char.match(/\./g) || []).length;
    return /^[0-9.]*$/.test(String(char)) && dotCount < 2;
  };

  isValidFormat = (value) => {
    // add case for `1` which is `1.00`
    return /^\d{1}\.\d{2}$/.test(String(value));
  };

  inRange = (value) => {
    const { min, max } = this.props;
    return value >= min && value <= max;
  };

  formatFloat = (value) => {
    return typeof value === "number" ? value.toFixed(2) : value;
  };

  setValue = (value) => {
    // if the value isn't valid / complete, update state
    // gross hack to get 1 treated as valid
    value = value === 1 ? `1.00` : value
    if (!this.isValidFormat(value)) {
      // update formatted value
      this.setState({
        value: this.formatFloat(value),
      });
    } else {
      // send valid value
      console.log(">> setting & sending value:", this.props.label, value);
      // update parent state
      this.props.onChange(value);
    }
  };

  handleInput = (e) => {
    let inputValue = e.target.value;

    if (
      !this.isAllowedChar(inputValue) ||
      !this.inRange(inputValue) ||
      !this.isMaxDecimal(inputValue)
    )
      return;

    this.setValue(inputValue);
  };

  handleKeyPress = (e) => {
    const { min, max, step } = this.props;
    switch (e.key) {
      case "Backspace":
        // console.log('backspace')
        break;
      // mimic native number box up/down arrows
      case "ArrowUp":
      case "ArrowDown":
        // prevent cursor from jumping
        e.preventDefault();

        // inc / dec
        const d = e.key === "ArrowUp" ? 1 : 0;
        const s = parseFloat(step);
        const v = parseFloat(this.state.value);
        let nextValue = eval(`${v} ${d ? "+" : "-"} ${s}`);
        const valid = this.inRange(nextValue);

        // gatekeep range
        if (!valid) {
          if (nextValue > max) {
            nextValue = max;
          } else if (nextValue < min) {
            nextValue = min;
          }
        }

        this.setValue(nextValue);
        break;

      // handle special scenarios for '.' entry
      case ".":
        const currentValue = this.state.value;
        // check if the field text all selected
        const {
          selectionStart,
          selectionEnd,
          value: inputValue,
        } = this.inputRef.current;
        const valueLength = inputValue.length;
        const selected = selectionStart === 0 && selectionEnd === valueLength;
        const emptyValue = currentValue === "";
        const newValue = emptyValue || selected ? "0." : currentValue;

        this.setValue(newValue);
        break;

      default:
        break;
    }
  };

  handleBlur = () => {
    const { precision } = this.props;
    const value = parseFloat(this.state.value).toFixed(precision);

    this.setValue(value);
  };

  handleFocus = () => {
    this.inputRef.current.select();
  };

  render() {
    const { label } = this.props;

    return (
      <div className={classnames("number-input", formatClassNames(label))}>
        <span className="react-numeric-input">
          <input
            ref={this.inputRef}
            type="text"
            onFocus={this.handleFocus}
            onKeyDown={this.handleKeyPress}
            onChange={this.handleInput}
            onBlur={this.handleBlur}
            disabled={this.props.disabled}
            value={this.state.value}
          />
        </span>
      </div>
    );
  }
} 
